/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import {ConfigService} from '@stackworx/react';
import ReactTable from 'react-table';
import Spinner from 'react-spinkit';
import {DropdownList} from 'react-widgets';

import {createFragmentContainer} from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EmailButton from '../../components/EmailButton';

import './DashboardViewDataModal.css';
import EmailDrilldownMutation from '../mutations/EmailDrilldownMutation';
import ViewDataModalStyle from './DashboardViewDataModal.module.css';
import DashboardCategories from './DashboardCategories';
import ExcelDownloadButton from '../../components/ExcelDownloadButton';

import {DashboardViewDataModal_report} from './__generated__/DashboardViewDataModal_report.graphql';
import {Environment} from 'relay-runtime';
import {DashboardViewDataModal_sales} from './__generated__/DashboardViewDataModal_sales.graphql';

interface Props {
  onClose: () => void;
  environment: Environment;
  isLoading: boolean;
  selectedEntityReference: string;
  authToken: string;
  report: DashboardViewDataModal_report;
  categoryType: string;
  handleCategoryChange: (category: string) => void;
}

interface ContentProps {
  buildDrillDownUri: (category: string, entityReference: string) => string;
  onClose: () => void;
  isLoading: boolean;
  category: string;
  handleCategoryChange: (category: string) => void;
  // TOOD: remove
  data: any;
  columns: any;
  entityReference: string;
  environment: Environment;
}

const ComboItem = (data: any) => {
  if (data) {
    return <span>{data.item.value}</span>;
  } else {
    return <span>Category Not Found</span>;
  }
};

const comboBoxCategories = (category: string) => {
  switch (category) {
    case 'AIRTIME':
    case 'VODACOMAIRTIME':
    case 'MTNAIRTIME':
    case 'TELKOMAIRTIME':
    case 'CELLCAIRTIME':
    case 'RINGAS':
    case 'C4C':
    case 'OTHERAIRTIME':
      return [
        {key: 'AIRTIME', value: 'Airtime'},
        {key: 'VODACOMAIRTIME', value: 'Vodacom'},
        {key: 'MTNAIRTIME', value: 'MTN'},
        {key: 'TELKOMAIRTIME', value: 'Telkom'},
        {key: 'CELLCAIRTIME', value: 'Cell C'},
        {key: 'RINGAS', value: 'Ringas'},
        {key: 'C4C', value: 'C4C'},
        {key: 'OTHERAIRTIME', value: 'Other'},
      ];
    case 'DATA':
    case 'VODACOMDATA':
    case 'MTNDATA':
    case 'TELKOMDATA':
    case 'CELLCDATA':
      return [
        {key: 'DATA', value: 'Data'},
        {key: 'VODACOMDATA', value: 'Vodacom'},
        {key: 'MTNDATA', value: 'MTN'},
        {key: 'TELKOMDATA', value: 'Telkom'},
        {key: 'CELLCDATA', value: 'Cell C'},
        {key: 'OTHERDATA', value: 'Other'},
      ];
    case 'ENTERTAINMENT':
    case 'HOLLOYWOODBETS':
    case 'LOTTOSTAR':
    case 'BLUVOUCHER':
    case 'OTHERENTERTAINMENT':
      return [
        {key: 'ENTERTAINMENT', value: 'Entertainment'},
        {key: 'HOLLOYWOODBETS', value: 'Hollywood Bets'},
        {key: 'LOTTOSTAR', value: 'Lotto Star'},
        {key: 'BLUVOUCHER', value: 'Blu Voucher'},
        {key: 'OTHERENTERTAINMENT', value: 'Other'},
      ];
    case 'TICKETING':
    case 'TICKETPRO':
    case 'BUSTICKETS':
    case 'OTHERTICKETING':
      return [
        {key: 'TICKETING', value: 'Ticketing'},
        {key: 'TICKETPRO', value: 'Ticket Pro'},
        {key: 'BUSTICKETS', value: 'Bus Tickets'},
        {key: 'OTHERTICKETING', value: 'Other'},
      ];
    case 'BILLING':
    case 'BLUBILL':
    case 'DSTV':
    case 'MUKURU':
    case 'ECOCASH':
    case 'MAMAMONEY':
    case 'HELLOPAISA':
    case 'PAY@':
    case 'EASYPAY':
    case 'OTHERBILLPAYMENTS':
      return [
        {key: 'BILLING', value: 'Billing'},
        {key: 'BLUBILL', value: 'Blu Bill'},
        {key: 'DSTV', value: 'DSTV'},
        {key: 'MUKURU', value: 'Mukuru'},
        {key: 'ECOCASH', value: 'Eco Cash'},
        {key: 'MAMAMONEY', value: 'Mama Money'},
        {key: 'HELLOPAISA', value: 'Hello Paisa'},
        {key: 'PAY@', value: 'Pay@'},
        {key: 'EASYPAY', value: 'EasyPay'},
        {key: 'OTHERBILLPAYMENTS', value: 'Other'},
      ];
    case 'ELECTRICITY':
    case 'OTHERELECTRICITY':
    case 'UNIPIN':
      return [
        {key: 'ELECTRICITY', value: 'Electricity'},
        {key: 'UNIPIN', value: 'Unipin'},
        {key: 'OTHERELECTRICITY', value: 'Other'},
      ];
    case 'OTHER':
    case 'RICA':
    case 'M2M':
      return [
        {key: 'OTHER', value: 'Other'},
        {key: 'RICA', value: 'RICA'},
        {key: 'M2M', value: 'M2M'},
      ];
    default:
      return [{key: 'CATEGORYNOTFOUND', value: 'Category Not Found'}];
  }
};

function Content({
  onClose,
  isLoading,
  category,
  handleCategoryChange,
  data,
  columns,
  environment,
  entityReference,
  buildDrillDownUri,
}: ContentProps) {
  const heading = DashboardCategories[category];

  if (!heading) {
    throw new Error(`Invalid Category: ${category}`);
  }

  const subheading = `Drilldown of ${heading}`;

  return (
    <div className="outer-container">
      <div
        id="modal-overlay"
        role="button"
        className="modal-overlay"
        onClick={onClose}
        tabIndex={0}
      />
      <div id="inner-body" className="modal-body drilldown">
        <div
          className="modal-close"
          onClick={onClose}
          role="button"
          tabIndex={0}
        >
          x
        </div>
        {isLoading ? (
          <Spinner
            className="data-viewer"
            name="circle"
            color="darkblue"
            fadeIn="none"
            style={{margin: '0 auto'}}
          />
        ) : (
          <div id="data-body" className="data-viewer">
            <h4>{heading}</h4>
            <p className="last-update">{subheading}</p>
            <DropdownList
              data={comboBoxCategories(category)}
              itemComponent={ComboItem}
              defaultValue={category}
              value={heading}
              // inputProps={{ readOnly: true }}
              onChange={(textInput) => {
                if (typeof textInput === 'object') {
                  handleCategoryChange(textInput.key);
                } // else user is typing
              }}
              textField="value"
              valueField="key"
              minLength={2}
            />
            <div className={ViewDataModalStyle['horizontal-scrolling']}>
              {'<- Scroll horizontally to see all data ->'}
            </div>
            <ReactTable
              className="data-table -striped"
              data={data}
              columns={columns}
              minRows={5}
              noDataText="Loading error"
              showPagination
              showPageSizeOptions={false}
              defaultPageSize={20}
              defaultSorting={[
                {
                  id: 'SpokeName',
                  // @ts-expect-error upgrade
                  desc: undefined, // not necessary unless set to true, but it's good to know its there.
                },
              ]}
            />
            <div className="button-container push-down-20">
              <EmailButton
                handleClick={async (email: string) => {
                  await EmailDrilldownMutation(environment, {
                    input: {
                      email: [email],
                      category,
                      entityRef: entityReference,
                    },
                  });
                }}
              />
              <ExcelDownloadButton
                href={buildDrillDownUri(category, entityReference)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
function DashboardViewDataModal({
  categoryType,
  report,
  authToken,
  environment,
  isLoading,
  onClose,
  selectedEntityReference,
  handleCategoryChange,
}: Props) {
  const buildDrillDownUri = React.useCallback(
    (category: string, entityReference: string) => {
      return encodeURI(
        `${ConfigService.serverUri}/report/drillDown?category=${category}&entityRef=${entityReference}&token=${authToken}`
      );
    },
    [authToken]
  );
  const data = React.useMemo(() => {
    const d: Omit<DashboardViewDataModal_sales, ' $refType'>[] = [];
    report.forEach((entity) => {
      if (entity.entity !== 'rollUp') {
        if (categoryType === 'AIRTIME') {
          entity.categories.airtime &&
            d.push({
              ...entity.categories.airtime.totalRollup,
            });
        } else if (categoryType === 'ENTERTAINMENT') {
          entity.categories.entertainment &&
            d.push({
              ...entity.categories.entertainment.totalRollup,
            });
        } else if (categoryType === 'DATA') {
          entity.categories.data &&
            d.push({
              ...entity.categories.data.totalRollup,
            });
        } else if (categoryType === 'TICKETING') {
          entity.categories.ticketing &&
            d.push({
              ...entity.categories.ticketing.totalRollup,
            });
        } else if (categoryType === 'BILLING') {
          entity.categories.billPayments &&
            d.push({
              ...entity.categories.billPayments.totalRollup,
            });
        } else if (categoryType === 'ELECTRICITY') {
          entity.categories.electricity &&
            d.push({
              ...entity.categories.electricity.totalRollup,
            });
        } else if (categoryType === 'OTHER') {
          entity.categories.other &&
            d.push({
              ...entity.categories.other.totalRollup,
            });

          // Check sub categories
        } else {
          entity.categories.airtime &&
            entity.categories.airtime.categories.forEach((r) => {
              if (r) {
                if (categoryType === r.key.toUpperCase()) {
                  d.push({
                    ...r,
                  });
                }
              }
            });
          entity.categories.data &&
            entity.categories.data.categories.forEach((r) => {
              if (r) {
                if (categoryType === r.key.toUpperCase()) {
                  d.push({
                    ...r,
                  });
                }
              }
            });
          entity.categories.entertainment &&
            entity.categories.entertainment.categories.forEach((r) => {
              if (r) {
                if (categoryType === r.key.toUpperCase()) {
                  d.push({
                    ...r,
                  });
                }
              }
            });
          entity.categories.ticketing &&
            entity.categories.ticketing.categories.forEach((r) => {
              if (r) {
                if (categoryType === r.key.toUpperCase()) {
                  d.push({
                    ...r,
                  });
                }
              }
            });
          entity.categories.other &&
            entity.categories.other.categories.forEach((r) => {
              if (r) {
                if (categoryType === r.key.toUpperCase()) {
                  d.push({
                    ...r,
                  });
                }
              }
            });
          entity.categories.billPayments &&
            entity.categories.billPayments.categories.forEach((r) => {
              if (r) {
                if (categoryType === r.key.toUpperCase()) {
                  d.push({
                    ...r,
                  });
                }
              }
            });
          entity.categories.electricity &&
            entity.categories.electricity.categories.forEach((r) => {
              if (r) {
                if (categoryType === r.key.toUpperCase()) {
                  d.push({
                    ...r,
                  });
                }
              }
            });
        }
      }
    });

    return d;
  }, [report, categoryType]);

  const columns = [
    {
      Header: 'Spoke',
      // TODO: account number
      accessor: 'spokeAcc',
      Cell: ({value}: any) => {
        return <div className="table-cell">{value}</div>;
      },
      width:
        window.innerWidth <= 425
          ? 120
          : window.innerWidth > 425 && window.innerWidth < 1023
          ? 200
          : undefined,
    },
    {
      Header: 'Spoke Name',
      accessor: 'spoke',
      Cell: ({value}) => <div className="table-cell">{value}</div>,
      width: window.innerWidth < 1023 ? 200 : undefined,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({value}: any) => {
        return <div className="table-cell">{value}</div>;
      },
      width: window.innerWidth < 1023 ? 200 : undefined,
    },
    {
      Header: 'Cell Number',
      accessor: 'cellNumber',
      Cell: ({value}: any) => {
        return <div className="table-cell">{value}</div>;
      },
      width: window.innerWidth < 1023 ? 200 : undefined,
    },
  ];

  columns.splice(2, 0, {
    Header: 'LMth',
    accessor: 'lastMonth',
    Cell: ({value}: any) => <div className="table-cell amount">R {value}</div>,
    width: window.innerWidth < 1023 ? 200 : undefined,
  });
  columns.splice(2, 0, {
    Header: 'LstMTD',
    accessor: 'lastMonthMonthToDate',
    Cell: ({value}: any) => <div className="table-cell amount">R {value}</div>,
    width: window.innerWidth < 1023 ? 200 : undefined,
  });
  columns.splice(2, 0, {
    Header: 'MTD',
    accessor: 'currentMonthToDate',
    Cell: ({value}: any) => <div className="table-cell amount">R {value}</div>,
    width: window.innerWidth < 1023 ? 200 : undefined,
  });
  columns.splice(2, 0, {
    Header: 'YsTD',
    accessor: 'yesterdaysSalesToDate',
    Cell: ({value}: any) => <div className="table-cell amount">R {value}</div>,
    width: window.innerWidth < 1023 ? 200 : undefined,
  });
  return (
    <Content
      columns={columns}
      onClose={onClose}
      environment={environment}
      isLoading={isLoading}
      buildDrillDownUri={(category, entityReference) => {
        return buildDrillDownUri(category, entityReference);
      }}
      data={data}
      category={categoryType}
      entityReference={selectedEntityReference}
      handleCategoryChange={handleCategoryChange}
    />
  );
}

graphql`
  fragment DashboardViewDataModal_sales on DetailedSalesReportSales {
    spoke
    spokeAcc
    email
    cellNumber
    isNull
    name
    key
    yesterdaysSalesToDate
    currentMonthToDate
    lastMonth
    lastMonthMonthToDate
  }
`;

graphql`
  fragment DashboardViewDataModal_category on DetailedSalesReportCategory {
    categories {
      ...DashboardViewDataModal_sales @relay(mask: false)
    }
    totalRollup {
      ...DashboardViewDataModal_sales @relay(mask: false)
    }
  }
`;

export default createFragmentContainer(DashboardViewDataModal, {
  report: graphql`
    fragment DashboardViewDataModal_report on DetailedSalesReport
    @relay(plural: true) {
      entity
      categories {
        airtime {
          ...DashboardViewDataModal_category @relay(mask: false)
        }
        data {
          ...DashboardViewDataModal_category @relay(mask: false)
        }
        billPayments {
          ...DashboardViewDataModal_category @relay(mask: false)
        }
        entertainment {
          ...DashboardViewDataModal_category @relay(mask: false)
        }
        ticketing {
          ...DashboardViewDataModal_category @relay(mask: false)
        }
        electricity {
          ...DashboardViewDataModal_category @relay(mask: false)
        }
        other {
          ...DashboardViewDataModal_category @relay(mask: false)
        }
      }
    }
  `,
});
